import { render } from "./media-content.vue?vue&type=template&id=65903338"
import script from "./media-content.vue?vue&type=script&lang=js"
export * from "./media-content.vue?vue&type=script&lang=js"

import "./media-content.vue?vue&type=style&index=0&id=65903338&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/media-content.vue'],['render',render],['__file',"media-content.vue"]])

export default __exports__